import { Injectable } from '@angular/core';
import { BehaviorSubject, lastValueFrom, Observable, shareReplay } from 'rxjs';
import { Asset } from '@app/shared/models/asset.model';
import { LiveAssetStatus } from '@app/shared/models/live-status.model';
import { AssetService } from '@core/services/asset.service';

@Injectable()
export class AssetStoreService {
    asset$: Observable<Asset>;
    private assetSubject: BehaviorSubject<Asset>;
    private statusSubject: BehaviorSubject<LiveAssetStatus>;

    constructor(private assetService: AssetService) {
        this.assetSubject = new BehaviorSubject<Asset>(undefined);
        this.statusSubject = new BehaviorSubject<LiveAssetStatus>(undefined);
        this.asset$ = this.assetSubject.asObservable().pipe(shareReplay(1));
    }

    get asset(): Asset {
        return this.assetSubject.getValue();
    }

    get status$(): Observable<LiveAssetStatus> {
        return this.statusSubject.asObservable();
    }

    set(asset: Asset): void {
        this.assetSubject.next(asset);
        void this.refreshStatus();
    }

    reset() {
        this.assetSubject.next(undefined);
        void this.refreshStatus();
    }

    async refreshStatus() {
        if (this.asset) {
            const status = await lastValueFrom(this.assetService.getLiveStatus(this.asset.id));
            this.statusSubject.next(status);
        } else {
            this.statusSubject.next(undefined);
        }
    }
}
